
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as demoN8Ino1D5Lh_JKXXO_xQ6sk_c89oxgCU89uXzhX_C1t8Meta } from "/opt/jenkins/workspace/Tenda/pages/demo.vue?macro=true";
import { default as indexeVoXw1wis3HF2Nt7hSYAgcvgNhDHVk1ciWTmQNu5aBIMeta } from "/opt/jenkins/workspace/Tenda/pages/index.vue?macro=true";
import { default as pklM7wQ2ZCwH8R3YxjA2Gr1fygqARvW0uVNyroMIWhS4sMeta } from "/opt/jenkins/workspace/Tenda/pages/store/pk.vue?macro=true";
import { default as cartzTCWCU6pVKfkj8LLATHbBJD5pASX3b4IE1taFtWaxDwMeta } from "/opt/jenkins/workspace/Tenda/pages/store/cart.vue?macro=true";
import { default as indexRe4pykKXVvJoumoY4vSdttDRf6YalXaLfELwECbU4a0Meta } from "/opt/jenkins/workspace/Tenda/pages/store/index.vue?macro=true";
import { default as joinPe0rb2DCI9mGKPc2QWDTtlmV6Hvo8s64MYTIfcfP_EMMeta } from "/opt/jenkins/workspace/Tenda/pages/website/join.vue?macro=true";
import { default as index3oClSFrjt5Q8Cnl6uR3iJESU9gRrxxtxl6mPWVElknEMeta } from "/opt/jenkins/workspace/Tenda/pages/store/order/index.vue?macro=true";
import { default as _91id_93Tn_oJKmBvD_34JQubJATZFd6WmB9nLO7zcLpdJ1FRscMeta } from "/opt/jenkins/workspace/Tenda/pages/website/case/[id].vue?macro=true";
import { default as infoMVd6U2NjamQ99043is4lw6DSWqizBq_2Rl3AMzMSVmEMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/info.vue?macro=true";
import { default as agency_45queryreIXoy6rpVoxiwxJvhbSgCN5HjWDseJSL8Ib56VkzZ4Meta } from "/opt/jenkins/workspace/Tenda/pages/store/agency-query.vue?macro=true";
import { default as indexE3GU9lUq3m6G9tIAqCBMu8ttGC8lvhmh5ud5t3Cx_C4Meta } from "/opt/jenkins/workspace/Tenda/pages/store/search/index.vue?macro=true";
import { default as indexnR2gnAACKatUc_5dIFADupJ1nYXnY3NZGa0mPMRSMKUMeta } from "/opt/jenkins/workspace/Tenda/pages/website/case/index.vue?macro=true";
import { default as indexCSFzkdMnHOfVeXFQCpSfC4zPKwmgNwkuZz5omjeIDT4Meta } from "/opt/jenkins/workspace/Tenda/pages/store/account/index.vue?macro=true";
import { default as _91id_93H7Ik4AUP51snICon_Ixk4_yiWEYQhLuRed7UPnknpBcMeta } from "/opt/jenkins/workspace/Tenda/pages/store/category/[id].vue?macro=true";
import { default as index14_Xi7_7yv1kKt4YtEKnbg7_LuGTW9SepbOo8cis6GsMeta } from "/opt/jenkins/workspace/Tenda/pages/store/pay-way/index.vue?macro=true";
import { default as _91id_93CzDHizgA3JhHc3mMkI2PdfysUfF3vNmRNFnpi7t2kmsMeta } from "/opt/jenkins/workspace/Tenda/pages/store/products/[id].vue?macro=true";
import { default as creditMVzNf97QpgHAfwrTxz7UJH_94O76y5_Y4Lo7UNctJ1oMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/credit.vue?macro=true";
import { default as index0Gi7ZxBIakUA6oYMzqrapcvxci5aauZan7_UQpzecogMeta } from "/opt/jenkins/workspace/Tenda/pages/store/activity/index.vue?macro=true";
import { default as indexkfN85ztKNfY1rqKUvyL8Ylm3P1ZBQw1VmLzNOshVvhEMeta } from "/opt/jenkins/workspace/Tenda/pages/store/products/index.vue?macro=true";
import { default as coupons6z0S2utJBUKBq74V_iSSK_F6AW5Xz3R6z2mHp8kEJM0Meta } from "/opt/jenkins/workspace/Tenda/pages/store/account/coupons.vue?macro=true";
import { default as coupon_45productsc6laqf_HYDd_UvPWAh9OQMo4ag9kY75_3qvVq6VqA2YMeta } from "/opt/jenkins/workspace/Tenda/pages/store/coupon-products.vue?macro=true";
import { default as index9vjV9HTS8oKDzbxEeIULVml_k9uDfirAtBZK9SQQ778Meta } from "/opt/jenkins/workspace/Tenda/pages/website/profile/index.vue?macro=true";
import { default as indexfhcNUu2pkdiiXpfvZsMOTlw_XErWj8WW0eFaumqhBroMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/index.vue?macro=true";
import { default as passwordXsh1QT00LnsCHboyPROzZpLj6armu2TMZ9Wqqr8qCh8Meta } from "/opt/jenkins/workspace/Tenda/pages/store/account/password.vue?macro=true";
import { default as _91id_93NRTydvOgBcWiY_r2pdLYLkzMDZaFUdwbRJTR2ghLOkoMeta } from "/opt/jenkins/workspace/Tenda/pages/website/solutions/[id].vue?macro=true";
import { default as ListDsJJXW7bt6xxeaZdKfW5acRShlUqGbBH6YfhJYkiZ7sMeta } from "/opt/jenkins/workspace/Tenda/pages/website/solutions/List.vue?macro=true";
import { default as addresses4vUXjbxcE2LWP6w4RKCo1LL5w_kSxLK1c1LmjckP7ZoMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/addresses.vue?macro=true";
import { default as favoritesSK6LCXGx_eU3z_MUbNKFzRP0FP8zX_St10Sps_H_XgIMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/favorites.vue?macro=true";
import { default as solutions70kx4rQqq1XvpLnl4TkgjDsf7nm6o7cn_BEiTj8UMncMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/solutions.vue?macro=true";
import { default as indexpEFt60j08W52rxCoUC6wAZchT52v4CC0I8Z4C_vBufkMeta } from "/opt/jenkins/workspace/Tenda/pages/website/solutions/index.vue?macro=true";
import { default as delistedX2_Ng6hMy_bbSf9zWVfIL47yd__s3HhBkuKL0y68YXkMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/delisted.vue?macro=true";
import { default as _91id_93CScfhITbG9_ZYFS92mUDOjL5d9CUqoN8_pASXe43MQoMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/orders/[id].vue?macro=true";
import { default as _91id_93soD8fgugJdrRB7BzDmSzEti2pbCtvF5LTlU6PJ8zjZ0Meta } from "/opt/jenkins/workspace/Tenda/pages/website/service/help/[id].vue?macro=true";
import { default as indexkQ1_ueNaiU8ANZ3B8_LUNBUfvyaqtbw_rQcCXEERTqYMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/orders/index.vue?macro=true";
import { default as indexYFul4ieQ34SRhE0JPrzvVMHZT_uAFU9VUnY93UImoS0Meta } from "/opt/jenkins/workspace/Tenda/pages/website/service/help/index.vue?macro=true";
import { default as certificationWVvx_5Wj_8lt1ToSFSvitM3adtiTq_tQj4VXceJldHoMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/certification.vue?macro=true";
import { default as applyM2fInmxQOYMX84ZoP9lwg6hRuqFCF8r68ZRbJ4vwfdsMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/refound/apply.vue?macro=true";
import { default as index0Q2FlPi_sy1_6FjNGWYpY5W6Bjn9Tla2oyZ6l7Ew1GsMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/reviews/index.vue?macro=true";
import { default as detailcCzZNQ2WGGBXp3dBE7SfVPFMqLo1UasLfHiEJQQUVK8Meta } from "/opt/jenkins/workspace/Tenda/pages/store/account/refound/detail.vue?macro=true";
import { default as indexArY9BlvvlO0vCZH4PdjXBktoer88FGhWyrsasAgrldYMeta } from "/opt/jenkins/workspace/Tenda/pages/store/order-pay-result/index.vue?macro=true";
import { default as _91id_93MTM8P8xCY41XbN_asQGfM5659265APJyqelVqCLjohIMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/download/[id].vue?macro=true";
import { default as media_45previewvxhZAkHwJ2HJ2qMrLO09VnFS60ccyAsLugXM0xb8_4IMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/media-preview.vue?macro=true";
import { default as _91type_93F__fPLjNoGihCH9SH_qO8rtJOHkYDSjeH_O4AgicstMMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/policy/[type].vue?macro=true";
import { default as product_45config_45previewDliV_3VG_iUHZvjfjzIRvWTrTsrZgKY_kEQw2MlDhKcMeta } from "/opt/jenkins/workspace/Tenda/pages/website/product-config-preview.vue?macro=true";
import { default as indexvl1JLS0wmlZ9MQxRd3_Kv60yqN5ea470xb0LJcSClJEMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/download/index.vue?macro=true";
import { default as indexDkb_lcDkkj_jORVQhpz27J_HYlQNNq_uYqA78Glk8ygMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/after-sales/index.vue?macro=true";
import { default as indexXkxFC2OTUR7k0gRQIUKxBf_Zz_lZQJrW_PAkRwezKc0Meta } from "/opt/jenkins/workspace/Tenda/pages/store/order-submit-result/index.vue?macro=true";
import { default as _91id_93jdXt8O6LfLVqrYGmXiXBbVMhp4VHhBrhNEUQ4t3UIhQMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/announcement/[id].vue?macro=true";
import { default as index1GQKqOlahdX7ztYer01dMUjEu8GV2_clRwLCEkVeaEcMeta } from "/opt/jenkins/workspace/Tenda/pages/website/service/announcement/index.vue?macro=true";
import { default as applyYii_nwx7LI0NmONAEuOAKHrs_Dmrs7ZxnmZbKbPZJQkMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/apply.vue?macro=true";
import { default as index719waKzyhAmvzsvXN3JdYiuLPSiZzxv3Zd0pufKPEHcMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/index.vue?macro=true";
import { default as resubmitm9H4hrLQEKfpUExvoN_CW1xerPNwDzc8wNgITO7f7ZwMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/resubmit.vue?macro=true";
import { default as materialskW0TDXGVGuB9_qLdr6_U26CisTEWjBepRdqie10_XNUMeta } from "/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/materials.vue?macro=true";
export default [
  {
    name: "demo",
    path: "/demo",
    meta: demoN8Ino1D5Lh_JKXXO_xQ6sk_c89oxgCU89uXzhX_C1t8Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/demo.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexeVoXw1wis3HF2Nt7hSYAgcvgNhDHVk1ciWTmQNu5aBIMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/index.vue")
  },
  {
    name: "store-pk",
    path: "/store/pk",
    meta: pklM7wQ2ZCwH8R3YxjA2Gr1fygqARvW0uVNyroMIWhS4sMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/pk.vue")
  },
  {
    name: "store-cart",
    path: "/store/cart",
    meta: cartzTCWCU6pVKfkj8LLATHbBJD5pASX3b4IE1taFtWaxDwMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/cart.vue")
  },
  {
    name: "store",
    path: "/store",
    meta: indexRe4pykKXVvJoumoY4vSdttDRf6YalXaLfELwECbU4a0Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/index.vue")
  },
  {
    name: "website-join",
    path: "/website/join",
    meta: joinPe0rb2DCI9mGKPc2QWDTtlmV6Hvo8s64MYTIfcfP_EMMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/join.vue")
  },
  {
    name: "store-order",
    path: "/store/order",
    meta: { ...(index3oClSFrjt5Q8Cnl6uR3iJESU9gRrxxtxl6mPWVElknEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/order/index.vue")
  },
  {
    name: "website-case-id",
    path: "/website/case/:id()",
    meta: _91id_93Tn_oJKmBvD_34JQubJATZFd6WmB9nLO7zcLpdJ1FRscMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/case/[id].vue")
  },
  {
    name: "store-account-info",
    path: "/store/account/info",
    meta: { ...(infoMVd6U2NjamQ99043is4lw6DSWqizBq_2Rl3AMzMSVmEMeta || {}), ...{"middleware":["auth","account-mobile-only"]} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/info.vue")
  },
  {
    name: "store-agency-query",
    path: "/store/agency-query",
    meta: agency_45queryreIXoy6rpVoxiwxJvhbSgCN5HjWDseJSL8Ib56VkzZ4Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/agency-query.vue")
  },
  {
    name: "store-search",
    path: "/store/search",
    meta: indexE3GU9lUq3m6G9tIAqCBMu8ttGC8lvhmh5ud5t3Cx_C4Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/search/index.vue")
  },
  {
    name: "website-case",
    path: "/website/case",
    meta: indexnR2gnAACKatUc_5dIFADupJ1nYXnY3NZGa0mPMRSMKUMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/case/index.vue")
  },
  {
    name: "store-account",
    path: "/store/account",
    meta: { ...(indexCSFzkdMnHOfVeXFQCpSfC4zPKwmgNwkuZz5omjeIDT4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/index.vue")
  },
  {
    name: "store-category-id",
    path: "/store/category/:id()",
    meta: _91id_93H7Ik4AUP51snICon_Ixk4_yiWEYQhLuRed7UPnknpBcMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/category/[id].vue")
  },
  {
    name: "store-pay-way",
    path: "/store/pay-way",
    meta: { ...(index14_Xi7_7yv1kKt4YtEKnbg7_LuGTW9SepbOo8cis6GsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/pay-way/index.vue")
  },
  {
    name: "store-products-id",
    path: "/store/products/:id()",
    meta: _91id_93CzDHizgA3JhHc3mMkI2PdfysUfF3vNmRNFnpi7t2kmsMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/products/[id].vue")
  },
  {
    name: "store-account-credit",
    path: "/store/account/credit",
    meta: { ...(creditMVzNf97QpgHAfwrTxz7UJH_94O76y5_Y4Lo7UNctJ1oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/credit.vue")
  },
  {
    name: "store-activity",
    path: "/store/activity",
    meta: index0Gi7ZxBIakUA6oYMzqrapcvxci5aauZan7_UQpzecogMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/activity/index.vue")
  },
  {
    name: "store-products",
    path: "/store/products",
    meta: indexkfN85ztKNfY1rqKUvyL8Ylm3P1ZBQw1VmLzNOshVvhEMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/products/index.vue")
  },
  {
    name: "store-account-coupons",
    path: "/store/account/coupons",
    meta: coupons6z0S2utJBUKBq74V_iSSK_F6AW5Xz3R6z2mHp8kEJM0Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/coupons.vue")
  },
  {
    name: "store-coupon-products",
    path: "/store/coupon-products",
    meta: coupon_45productsc6laqf_HYDd_UvPWAh9OQMo4ag9kY75_3qvVq6VqA2YMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/coupon-products.vue")
  },
  {
    name: "website-profile",
    path: "/website/profile",
    meta: index9vjV9HTS8oKDzbxEeIULVml_k9uDfirAtBZK9SQQ778Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/profile/index.vue")
  },
  {
    name: "website-service",
    path: "/website/service",
    meta: indexfhcNUu2pkdiiXpfvZsMOTlw_XErWj8WW0eFaumqhBroMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/index.vue")
  },
  {
    name: "store-account-password",
    path: "/store/account/password",
    meta: { ...(passwordXsh1QT00LnsCHboyPROzZpLj6armu2TMZ9Wqqr8qCh8Meta || {}), ...{"middleware":["auth","account-mobile-only"]} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/password.vue")
  },
  {
    name: "website-solutions-id",
    path: "/website/solutions/:id()",
    meta: _91id_93NRTydvOgBcWiY_r2pdLYLkzMDZaFUdwbRJTR2ghLOkoMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/solutions/[id].vue")
  },
  {
    name: "website-solutions-List",
    path: "/website/solutions/List",
    meta: ListDsJJXW7bt6xxeaZdKfW5acRShlUqGbBH6YfhJYkiZ7sMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/solutions/List.vue")
  },
  {
    name: "store-account-addresses",
    path: "/store/account/addresses",
    meta: addresses4vUXjbxcE2LWP6w4RKCo1LL5w_kSxLK1c1LmjckP7ZoMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/addresses.vue")
  },
  {
    name: "store-account-favorites",
    path: "/store/account/favorites",
    meta: { ...(favoritesSK6LCXGx_eU3z_MUbNKFzRP0FP8zX_St10Sps_H_XgIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/favorites.vue")
  },
  {
    name: "store-account-solutions",
    path: "/store/account/solutions",
    meta: { ...(solutions70kx4rQqq1XvpLnl4TkgjDsf7nm6o7cn_BEiTj8UMncMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/solutions.vue")
  },
  {
    name: "website-solutions",
    path: "/website/solutions",
    meta: indexpEFt60j08W52rxCoUC6wAZchT52v4CC0I8Z4C_vBufkMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/solutions/index.vue")
  },
  {
    name: "website-service-delisted",
    path: "/website/service/delisted",
    meta: delistedX2_Ng6hMy_bbSf9zWVfIL47yd__s3HhBkuKL0y68YXkMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/delisted.vue")
  },
  {
    name: "store-account-orders-id",
    path: "/store/account/orders/:id()",
    meta: _91id_93CScfhITbG9_ZYFS92mUDOjL5d9CUqoN8_pASXe43MQoMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/orders/[id].vue")
  },
  {
    name: "website-service-help-id",
    path: "/website/service/help/:id()",
    meta: _91id_93soD8fgugJdrRB7BzDmSzEti2pbCtvF5LTlU6PJ8zjZ0Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/help/[id].vue")
  },
  {
    name: "store-account-orders",
    path: "/store/account/orders",
    meta: { ...(indexkQ1_ueNaiU8ANZ3B8_LUNBUfvyaqtbw_rQcCXEERTqYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/orders/index.vue")
  },
  {
    name: "website-service-help",
    path: "/website/service/help",
    meta: indexYFul4ieQ34SRhE0JPrzvVMHZT_uAFU9VUnY93UImoS0Meta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/help/index.vue")
  },
  {
    name: "store-account-certification",
    path: "/store/account/certification",
    meta: { ...(certificationWVvx_5Wj_8lt1ToSFSvitM3adtiTq_tQj4VXceJldHoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/certification.vue")
  },
  {
    name: "store-account-refound-apply",
    path: "/store/account/refound/apply",
    meta: { ...(applyM2fInmxQOYMX84ZoP9lwg6hRuqFCF8r68ZRbJ4vwfdsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/refound/apply.vue")
  },
  {
    name: "store-account-reviews",
    path: "/store/account/reviews",
    meta: { ...(index0Q2FlPi_sy1_6FjNGWYpY5W6Bjn9Tla2oyZ6l7Ew1GsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/reviews/index.vue")
  },
  {
    name: "store-account-refound-detail",
    path: "/store/account/refound/detail",
    meta: { ...(detailcCzZNQ2WGGBXp3dBE7SfVPFMqLo1UasLfHiEJQQUVK8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/refound/detail.vue")
  },
  {
    name: "store-order-pay-result",
    path: "/store/order-pay-result",
    meta: { ...(indexArY9BlvvlO0vCZH4PdjXBktoer88FGhWyrsasAgrldYMeta || {}), ...{"middleware":["auth","order-pay-result-layout"]} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/order-pay-result/index.vue")
  },
  {
    name: "website-service-download-id",
    path: "/website/service/download/:id()",
    meta: _91id_93MTM8P8xCY41XbN_asQGfM5659265APJyqelVqCLjohIMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/download/[id].vue")
  },
  {
    name: "website-service-media-preview",
    path: "/website/service/media-preview",
    meta: media_45previewvxhZAkHwJ2HJ2qMrLO09VnFS60ccyAsLugXM0xb8_4IMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/media-preview.vue")
  },
  {
    name: "website-service-policy-type",
    path: "/website/service/policy/:type()",
    meta: _91type_93F__fPLjNoGihCH9SH_qO8rtJOHkYDSjeH_O4AgicstMMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/policy/[type].vue")
  },
  {
    name: "website-product-config-preview",
    path: "/website/product-config-preview",
    meta: product_45config_45previewDliV_3VG_iUHZvjfjzIRvWTrTsrZgKY_kEQw2MlDhKcMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/product-config-preview.vue")
  },
  {
    name: "website-service-download",
    path: "/website/service/download",
    meta: indexvl1JLS0wmlZ9MQxRd3_Kv60yqN5ea470xb0LJcSClJEMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/download/index.vue")
  },
  {
    name: "store-account-after-sales",
    path: "/store/account/after-sales",
    meta: { ...(indexDkb_lcDkkj_jORVQhpz27J_HYlQNNq_uYqA78Glk8ygMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/after-sales/index.vue")
  },
  {
    name: "store-order-submit-result",
    path: "/store/order-submit-result",
    meta: { ...(indexXkxFC2OTUR7k0gRQIUKxBf_Zz_lZQJrW_PAkRwezKc0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/order-submit-result/index.vue")
  },
  {
    name: "website-service-announcement-id",
    path: "/website/service/announcement/:id()",
    meta: _91id_93jdXt8O6LfLVqrYGmXiXBbVMhp4VHhBrhNEUQ4t3UIhQMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/announcement/[id].vue")
  },
  {
    name: "website-service-announcement",
    path: "/website/service/announcement",
    meta: index1GQKqOlahdX7ztYer01dMUjEu8GV2_clRwLCEkVeaEcMeta || {},
    component: () => import("/opt/jenkins/workspace/Tenda/pages/website/service/announcement/index.vue")
  },
  {
    name: "store-account-channel-certification-apply",
    path: "/store/account/channel-certification/apply",
    meta: { ...(applyYii_nwx7LI0NmONAEuOAKHrs_Dmrs7ZxnmZbKbPZJQkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/apply.vue")
  },
  {
    name: "store-account-channel-certification",
    path: "/store/account/channel-certification",
    meta: { ...(index719waKzyhAmvzsvXN3JdYiuLPSiZzxv3Zd0pufKPEHcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/index.vue")
  },
  {
    name: "store-account-channel-certification-resubmit",
    path: "/store/account/channel-certification/resubmit",
    meta: { ...(resubmitm9H4hrLQEKfpUExvoN_CW1xerPNwDzc8wNgITO7f7ZwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/resubmit.vue")
  },
  {
    name: "store-account-channel-certification-materials",
    path: "/store/account/channel-certification/materials",
    meta: { ...(materialskW0TDXGVGuB9_qLdr6_U26CisTEWjBepRdqie10_XNUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/opt/jenkins/workspace/Tenda/pages/store/account/channel-certification/materials.vue")
  }
]